import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import componentForItem from '../../../../util/componentForItem';
import { COMPONENT_EDIT } from '@instructure/quiz-common';
import { propsForInteractionEdit } from '../../../../util/interactionTypePropsHelper';
export var ItemOverride = /*#__PURE__*/function (_Component) {
  function ItemOverride() {
    var _this;
    _classCallCheck(this, ItemOverride);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ItemOverride, [].concat(args));
    _defineProperty(_this, "changeOverrideState", function (newState, changes) {
      if (changes) {
        _this.props.changeQuizEntryProperties(_this.props.quizEntry.id, {
          itemOverrides: changes
        });
      }
    });
    return _this;
  }
  _inherits(ItemOverride, _Component);
  return _createClass(ItemOverride, [{
    key: "render",
    value: function render() {
      var item = this.props.entry;
      var interactionType = item.getInteractionType().slug;
      var Interaction = componentForItem(interactionType, COMPONENT_EDIT);
      var propsForInteraction = propsForInteractionEdit(_objectSpread(_objectSpread({}, this.props), {}, {
        changeItemState: function changeItemState() {},
        openImportModal: function openImportModal() {},
        workingItem: item
      }));
      return /*#__PURE__*/React.createElement(Interaction, Object.assign({}, propsForInteraction, {
        changeItemState: this.changeOverrideState,
        itemId: this.props.guid,
        overrideEditableForItem: true
      }));
    }
  }]);
}(Component);
_defineProperty(ItemOverride, "propTypes", {
  changeQuizEntryProperties: PropTypes.func.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  guid: PropTypes.string.isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  // required by propsForInteractionEdit
  addError: PropTypes.func.isRequired,
  errorsAreShowing: PropTypes.bool,
  handleQuizEntryPointsChange: PropTypes.func.isRequired,
  interactionFileUpload: PropTypes.func.isRequired,
  occludeQuizEntries: PropTypes.func.isRequired,
  oneQuestionAtATime: PropTypes.bool.isRequired,
  parentId: PropTypes.string.isRequired,
  parentType: PropTypes.string.isRequired,
  partialDeepScoringEnabled: PropTypes.bool,
  partialScoringEnabled: PropTypes.bool,
  quizId: PropTypes.string.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  setOneQuestionAtATime: PropTypes.func.isRequired
});
_defineProperty(ItemOverride, "defaultProps", {
  errorsAreShowing: false,
  partialScoringEnabled: false,
  partialDeepScoringEnabled: false
});
export default ItemOverride;